import React from 'react';
import { StarIcon as StarIconLucide } from 'lucide-react';
export const AverageRatingSection = () => {
  return <section className="py-4 md:py-6 bg-bttf-bg border-t border-bttf-subtext/20 relative overflow-hidden" data-id="element-35">
      <div className="container mx-auto px-4 relative z-10 max-w-lg" data-id="element-36">
        <div className="border border-[#b8860b]/60 rounded-xl px-8 py-6 text-center bg-[#1a1408] shadow-[0_0_40px_rgba(184,134,11,0.25)]" data-id="element-37">
          <div className="flex justify-center gap-1.5 mb-3" data-id="element-38">
            {[...Array(5)].map((_, i) => <StarIconLucide key={i} className="h-7 w-7 text-[#FFB800] fill-[#FFB800]" data-id="element-39" />)}
          </div>
          <p className="text-2xl md:text-3xl font-bold font-future text-[#FFB800] mb-1" data-id="element-40">
            4.9/5 Average Rating
          </p>
          <p className="text-sm text-gray-400 font-body" data-id="element-41">
            From 12,847 Verified Collectors
          </p>
        </div>
      </div>
    </section>;
};